var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5a.755.755 0 0 0-.75.75c0 .422.328.75.75.75h1.922L7.21 8.734a.723.723 0 0 0 0 1.055.723.723 0 0 0 1.055 0L13 5.08V7c0 .422.328.75.75.75.398 0 .75-.328.75-.75V3.25a.771.771 0 0 0-.75-.75H10zm-5.625.75A1.866 1.866 0 0 0 2.5 5.125v7.5c0 1.055.82 1.875 1.875 1.875h7.5c1.031 0 1.875-.82 1.875-1.875V10a.771.771 0 0 0-.75-.75.755.755 0 0 0-.75.75v2.625c0 .21-.188.375-.375.375h-7.5A.37.37 0 0 1 4 12.625v-7.5c0-.188.164-.375.375-.375H7c.398 0 .75-.328.75-.75A.771.771 0 0 0 7 3.25H4.375z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectInactive);
export default __webpack_public_path__ + "static/media/redirect-inactive.4fabdd7c933b3f0c198643bd9b0ae0b9.svg";
export { ForwardRef as ReactComponent };